var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.token
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("h3", {
            class: _vm.$route.meta.title.styleClasses,
            domProps: { innerHTML: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-4" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "w-100 mt-2 darken",
                    staticStyle: {
                      "background-color": "#1ABC9C",
                      "border-color": "white"
                    },
                    attrs: { variant: "primary" },
                    on: {
                      click: function($event) {
                        _vm.openDialog(
                          _vm.getVideoConsultationUrl,
                          _vm.$t("menttum.appointment-dialog-msg"),
                          true
                        )
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "w-6 mr-2",
                      attrs: {
                        src: require("../../../../../static-appopensalud/img/icons/services/video-white.svg")
                      }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("menttum.video-consultation")) + "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "w-100 mt-2",
                    attrs: { variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.getWellnessUrl()
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "w-6 mr-2",
                      attrs: {
                        src: require("../../../../../static-appopensalud/img/icons/bienestar-logo.png")
                      }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("menttum.wellness-services")) + "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "w-100 mt-2 darken",
                    staticStyle: { "background-color": "white" },
                    attrs: { variant: "outline-primary" },
                    on: {
                      click: function($event) {
                        _vm.openDialog(
                          _vm.getWebappUrl,
                          _vm.$t("menttum.webapp-dialog-msg")
                        )
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "w-6 mr-2",
                      attrs: {
                        src: require("../../../../../static-appopensalud/img/icons/person.svg")
                      }
                    }),
                    _vm._v(_vm._s(_vm.$t("menttum.webapp")) + "\n      ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "w-100 mt-2 darken",
                    staticStyle: { "background-color": "white" },
                    attrs: { variant: "outline-primary" },
                    on: {
                      click: function($event) {
                        return _vm.$router.push("/patient/tests")
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "w-6 mr-2",
                      attrs: {
                        src: require("../../../../../static-appopensalud/img/icons/morillas-svg-icons/primary/self-test.svg")
                      }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("menttum.self-evaluation")) + "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "w-100 mt-2 darken",
                    staticStyle: {
                      "background-color": "#D2414C",
                      "border-color": "white"
                    },
                    attrs: { variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.openPacks(false)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "w-6 mr-2",
                      attrs: {
                        src: require("../../../../../static-appopensalud/img/icons/services/service-packages.svg")
                      }
                    }),
                    _vm._v(_vm._s(_vm.$t("menttum.hire-package")) + "\n      ")
                  ]
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm._m(0)
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              model: {
                value: _vm.packsTable.visible,
                callback: function($$v) {
                  _vm.$set(_vm.packsTable, "visible", $$v)
                },
                expression: "packsTable.visible"
              }
            },
            [
              _vm.packsTable.hireMsgVisible
                ? _c("p", [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("menttum.hire-package-msg")) +
                        "\n    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.packsTable.data && _vm.landingData
                ? _c("paginated-table", {
                    attrs: {
                      fields: _vm.packsTable.fields,
                      items: _vm.packsTable.data,
                      loading: _vm.$store.state.loading
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(hire)",
                          fn: function(data) {
                            return [
                              _c(
                                "base-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.$helpers.goToPatientWebApp(
                                        "requestAppointment/center/" +
                                          _vm.landingData.centerData.id +
                                          "/servicesPackages/" +
                                          data.item.id
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.$t("menttum.hire"))
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3740931354
                    )
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("base-dialog", {
            attrs: { okFn: _vm.goToPendingUrl, content: _vm.dialog.text },
            model: {
              value: _vm.dialog.visible,
              callback: function($$v) {
                _vm.$set(_vm.dialog, "visible", $$v)
              },
              expression: "dialog.visible"
            }
          })
        ],
        1
      )
    : _c("div", [
        _c("p", [_vm._v(_vm._s(_vm.$t("telemedcare.no-tmc-token-found")))])
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-5" }, [
      _c("span", { staticClass: "mr-3" }, [_vm._v("Powered by ")]),
      _c("a", { attrs: { href: "https://www.opensalud.es" } }, [
        _c("img", {
          staticStyle: { height: "40px", "vertical-align": "middle" },
          attrs: {
            src: "/static-appopensalud/img/logos/RGB_OPENSALUD_AZUL.svg"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64e95b8d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64e95b8d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/external/MenttumProxyView.vue
// module id = 3922
// module chunks = 76